const ANSWER_FRACTIONS = {
  zero: [0.8, 0.6, 0.4, 0.2, 0],
  one: [1, 0.8, 0.6, 0.4, 0.2],
  two: [0.8, 1, 0.8, 0.6, 0.4],
  three: [0.6, 0.8, 1, 0.8, 0.6],
  four: [0.4, 0.6, 0.8, 1, 0.8],
  five: [0.2, 0.4, 0.6, 0.8, 1]
}

export const flavourMixin = {
  data() {
    return {
      dataReady: false,
      theme: '',
      flavoursScores: {
        one: 3,
        two: 3,
        three: 3
      },
      flavours: {
        // 12YO elevated
        orchard: [
          {
            name: 'Pineapple',
            weight: 100,
            fractions: ANSWER_FRACTIONS.four
          },
          {
            name: 'Floral',
            weight: 50,
            fractions: ANSWER_FRACTIONS.three
          },
          {
            name: 'Vanilla',
            weight: 100,
            fractions: ANSWER_FRACTIONS.four
          },
          {
            name: 'Toffee',
            weight: 50,
            fractions: ANSWER_FRACTIONS.two
          },
          {
            name: 'Spice',
            weight: 50,
            fractions: ANSWER_FRACTIONS.one
          },
          {
            name: 'Peaty',
            weight: 100,
            fractions: ANSWER_FRACTIONS.zero
          },
          {
            name: 'Smoky',
            weight: 50,
            fractions: ANSWER_FRACTIONS.zero
          },
          {
            name: 'Pear',
            weight: 100,
            fractions: ANSWER_FRACTIONS.five
          }
        ],
        // 12YO ex islay casks
        smoke: [
          {
            name: 'Pineapple',
            weight: 50,
            fractions: ANSWER_FRACTIONS.two
          },
          {
            name: 'Floral',
            weight: 50,
            fractions: ANSWER_FRACTIONS.one
          },
          {
            name: 'Vanilla',
            weight: 50,
            fractions: ANSWER_FRACTIONS.two
          },
          {
            name: 'Toffee',
            weight: 100,
            fractions: ANSWER_FRACTIONS.three
          },
          {
            name: 'Spice',
            weight: 50,
            fractions: ANSWER_FRACTIONS.three
          },
          {
            name: 'Peaty',
            weight: 100,
            fractions: ANSWER_FRACTIONS.four
          },
          {
            name: 'Smoky',
            weight: 50,
            fractions: ANSWER_FRACTIONS.two
          },
          {
            name: 'Pear',
            weight: 100,
            fractions: ANSWER_FRACTIONS.three
          }
        ],
        // 12YO double charred
        chard: [
          {
            name: 'Pineapple',
            weight: 50,
            fractions: ANSWER_FRACTIONS.two
          },
          {
            name: 'Floral',
            weight: 50,
            fractions: ANSWER_FRACTIONS.one
          },
          {
            name: 'Vanilla',
            weight: 100,
            fractions: ANSWER_FRACTIONS.four
          },
          {
            name: 'Toffee',
            weight: 100,
            fractions: ANSWER_FRACTIONS.three
          },
          {
            name: 'Spice',
            weight: 50,
            fractions: ANSWER_FRACTIONS.two
          },
          {
            name: 'Peaty',
            weight: 50,
            fractions: ANSWER_FRACTIONS.zero
          },
          {
            name: 'Smoky',
            weight: 50,
            fractions: ANSWER_FRACTIONS.two
          },
          {
            name: 'Pear',
            weight: 100,
            fractions: ANSWER_FRACTIONS.four
          }
        ]
      }
    }
  },
  mounted() {
    this.onRouteChange()
  },
  computed: {
    classes() {
      return {
        [`Flavour--theme--${this.theme}`]: this.theme
      }
    }
  },
  methods: {
    async playSound(sound) {
      const audio = document.createElement('audio')
      const mp3 = require(`../assets/audio/${sound}.mp3`)
      if (audio.canPlayType('audio/mpeg')) {
        audio.setAttribute('src', mp3)
      }
      await audio.play()
    },
    flavoursParamToArray() {
      // Grabs the flavours from the URL so we can use in the range slider
      if (this.$route.query.flavours) {
        return this.$route.query.flavours.split(',')
      }
      return ''
    },
    activeStates() {
      if (this.theme) {
        const activeStates = this.flavours[this.theme].filter(item => item.active)
        //this.$log.info('activeStates', activeStates)
        return activeStates
      }
    },
    updateFlavourStates() {
      // Add active and animation states to Flavour data
      const themes = ['orchard', 'smoke', 'chard']
      themes.forEach(theme => {
        this.flavours[theme] = this.flavours[theme].map(item => {
          return {
            ...item,
            active: false,
            animate: false
          }
        })
      })
    },
    updateActiveStates() {
      // Grab active themes from URL and update local state
      const activeFlavours = this.flavoursParamToArray()
      if (activeFlavours) {
        this.flavours[this.theme] = this.flavours[this.theme].map(flavour => {
          let active = false
          activeFlavours.forEach(item => {
            if (item === flavour.name) {
              active = true
            }
          })
          return {
            ...flavour,
            active: active
          }
        })
      }
      this.dataReady = true
    },
    onRouteChange() {
      // Set theme. x3 possible variations.
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
      }
    }
  },
  watch:{
    $route (){
      // Need to watch route changes, in case use use browser back etc
      this.onRouteChange()
    }
  }
}
